import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Text from 'components/common/Text'
import { TEAL, media } from 'components/styles'

const StyledButton = styled.div`
  background-color: ${TEAL};
  ${media.small`height: 75px;`}
  ${media.huge`height: 75px;`}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8em;
  cursor: pointer;
`

class BackButton extends Component {
  render () {
    return (
      <StyledButton onClick={this.props.onClick}>
        <Text color='white'>Back to Editor</Text>
      </StyledButton>
    )
  }
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default BackButton



// WEBPACK FOOTER //
// ./src/components/editor/editorHeader/BackButton.js